module.exports = __webpack_public_path__ + "static/wire-about-2-bee13b58135d641dab84b5c6910a0432.png";